module.exports = __webpack_public_path__ + "img/logo6.eb8c3fcd.png";